module.exports = __webpack_public_path__ + "img/exercise-passed-3.cb48db4f.png";